import { render, staticRenderFns } from "./formGroup.vue?vue&type=template&id=81494bce&scoped=true"
import script from "./formGroup.vue?vue&type=script&lang=js"
export * from "./formGroup.vue?vue&type=script&lang=js"
import style0 from "./formGroup.vue?vue&type=style&index=0&id=81494bce&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81494bce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81494bce')) {
      api.createRecord('81494bce', component.options)
    } else {
      api.reload('81494bce', component.options)
    }
    module.hot.accept("./formGroup.vue?vue&type=template&id=81494bce&scoped=true", function () {
      api.rerender('81494bce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reverse/edition/components/form/steps/formGroup.vue"
export default component.exports